import { render, staticRenderFns } from "./ReturnsList.vue?vue&type=template&id=3989ff81&"
import script from "./ReturnsList.vue?vue&type=script&lang=js&"
export * from "./ReturnsList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnsList.vue?vue&type=style&index=0&id=3989ff81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports